import React from 'react';
import PropTypes from 'prop-types';
import { 
	Dialog, 
	DialogTitle, 
	DialogContent, 
	DialogActions
} from '@material-ui/core';
import Button from './button';
import Form from './Form';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

const TextEditorDialog = props => {
	const [value, setValue] = React.useState('');

	React.useEffect(() => {
		if (props.show) {
			setValue(props.value);
		}
	}, [props.show]);

	const onClose = () => {
		props.onCancel();
	};
	const onSubmit = () => {
		props.onOk(value);
	}
	return (
		<Dialog 
			fullWidth={true}
			maxWidth={false}
			open={props.show} 
			onClose={onClose} 
			style={{ zIndex: 9990 }}
			PaperProps={{
				style: {
					width: props.dialogWidth,
					maxWidth: props.dialogWidth,
					height: props.dialogHeight,
					maxHeight: props.dialogHeight
				}
			}}
			scroll='paper'
		>
			{props.title && <DialogTitle>{props.title}</DialogTitle>}
			<DialogContent style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
				<Form 
					onSubmit={onSubmit}
					style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
				>
					<TextareaAutosize
						minRows={props.minRows}
						style={{
							width: '100%',
							flex: 1,
							resize: 'none',
							padding: '12px',
							fontFamily: 'inherit',
							fontSize: '1rem',
							lineHeight: 1.5
						}}
						value={value}
						onChange={e => setValue(e.target.value)}
					/>
				</Form>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
	 			<Button onClick={onSubmit}>Ok</Button>
			</DialogActions>
		</Dialog>
	);
};

TextEditorDialog.propTypes = {
	show: PropTypes.bool,
	onCancel: PropTypes.func.isRequired,
	onOk: PropTypes.func.isRequired,
	value: PropTypes.string.isRequired,
	title: PropTypes.string,
	dialogWidth: PropTypes.string,
	dialogHeight: PropTypes.string,
	minRows: PropTypes.number
};

TextEditorDialog.defaultProps = {
	show: false,
	title: null,
	dialogWidth: '95vw',
	dialogHeight: '90vh',
	minRows: 20
};

export default TextEditorDialog;
